<style scoped lang="less">
  .footer{
    width: 100%;
    /*height: 398px;*/
    background: #000000;
    padding:80px 9% 44px;
    box-sizing: border-box;
    .footer_content{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .ma_list{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .ma{
          margin-right: 50px;
          img{
            width: 100px;
            height: 100px;
          }
          p{
            margin-top: 4px;
            height: 16px;
            font-size: 14px;
            color: #757475;
            width: 100px;
            text-align: center;
          }
        }
        .ma_s{
          display: flex;
          flex-direction: column;
          img{
            width: 26px;
            height: 21px;
            margin-bottom: 20px;
          }
        }
      }
      .contact{
        color: rgba(117, 116, 117, 1);
        .h3{
          font-size: 26px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #757475;
          margin-bottom: 20px;
        }
        .ll{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 10px;
          font-size: 15px;
          img{
            width: 20px;
            height: 20px;
            margin-right: 9px;
          }
        }
      }
    }
    .tips{
      width: 100%;
      text-align: center;
      margin-top: 100px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #757475;
      span{
        color: #3D8949;
      }
    }
  }
</style>
<template>
  <div class="footer">
    <div class="footer_content">
      <div class="ma_list">
        <div class="ma">
          <img src="https://img.gegejia.com/img/70321f611a95f5c9dfebb6cc8eff6a5c.png" alt="">
          <p>T97 合作申请</p>
        </div>
        <div class="ma">
          <img src="https://img.gegejia.com/img/377dbc50af4ef64c75bd06d965c85671.png" alt="">
          <p>T97 点单小程序</p>
        </div>
        <div class="ma">
          <img src="https://img.gegejia.com/img/42d253ca819ac0c70e3e00a47b14a4a6.png" alt="">
          <p>T97 微信公众号</p>
        </div>
        <div class="ma">
          <img src="https://img.gegejia.com/img/985a197b46e99b16684dc4946d7b5973.png" alt="">
          <p>T97 官方微博</p>
        </div>
        <div class="ma ma_s">
          <img src="https://img.gegejia.com/img/04f64e466b8b4a3513a902944be730f9.png" alt="">
          <img src="https://img.gegejia.com/img/724c722cf260dd2560a9310061082ed3.png" alt="">
        </div>
      </div>
      <div class="contact">
        <div class="h3">联系我们</div>
        <div class="ll">
          <img src="https://img.gegejia.com/img/5d7d3cbdee98f023357cd6e65cf3a7bc.png" alt="">
          <div class="p">总部地址：浙江省杭州市西湖区天目山路398号天目里A2区15号楼</div>
        </div>
        <div class="ll">
          <img src="https://img.gegejia.com/img/be3d48ed00a7ff52366e8ea5861c26eb.png" alt="">
          <div class="p">T97 COFFEE唯一官方网站：www.t97-coffee.com</div>
        </div>
        <div class="ll">
          <img src="https://img.gegejia.com/img/2cbc041ef45a4e07f5127db437d9ffa3.png" alt="">
          <div class="p">合作热线：400-025-9197</div>
        </div>
        <!--<div class="ll">-->
          <!--<img src="https://img.gegejia.com/img/410d1eac4ea326af2a1b5c6dbc31a747.png" alt="">-->
          <!--<div class="p">客服热线：400-xxx-xxx</div>-->
        <!--</div>-->

      </div>
    </div>
    <div class="tips">免责声明 | 隐私政策 | 版权公告© 1999-2020浙江格家网络技术有限公司版权所有 | <span>浙ICP备10030838号-6</span></div>
  </div>
</template>

<script>
  export default {

  }
</script>





// WEBPACK FOOTER //
// src/views/t97/block/footer.vue